import * as React from 'react';

import SearchIcon from '@/shared/assets/magnifyingglass.svg?react';
import XIcon from '@/shared/assets/xmark_filled.svg?react';
import { Input } from '@/shared/components/ui/input';

export interface SearchBarProps extends React.InputHTMLAttributes<HTMLInputElement> {
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
}

const SearchBar = ({ onChange, value, ...props }: SearchBarProps) => {
  const [inputValue, setInputValue] = React.useState(value || '');

  React.useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    onChange?.(e);
  };

  const handleClear = () => {
    setInputValue('');
    const event = {
      target: { value: '' },
    } as React.ChangeEvent<HTMLInputElement>;
    onChange?.(event);
  };

  return (
    <Input
      value={inputValue}
      onChange={handleChange}
      variant="search-bar"
      prefixIcon={<SearchIcon className="size-4 cursor-pointer text-white" />}
      suffixIcon={
        inputValue && (
          <XIcon
            className="size-4 cursor-pointer text-white"
            onClick={handleClear}
          />
        )
      }
      {...props}
    />
  );
};

export default SearchBar;
